module.exports = __webpack_public_path__ + "static/media/footer__twitter.e125b409.svg";